import axios from 'axios';
import { Message } from 'element-ui';
import { API_CODE } from '@/api/constants';
import { handleBannedWordError } from '@/utils/bannedWordHandler';
import { handleLoginExpired } from '@/utils/loginExpiredHandler';

// 错误消息去重控制（相同消息 3 秒内只显示一次）
let lastErrorMessage = '';
let lastErrorTime = 0;
const ERROR_DEDUP_MS = 3000;

function showErrorMessage(message) {
  const now = Date.now();
  if (message === lastErrorMessage && now - lastErrorTime < ERROR_DEDUP_MS) {
    return;
  }
  lastErrorMessage = message;
  lastErrorTime = now;
  Message({
    message,
    type: 'error',
    duration: 3000
  });
}

// 创建 axios 实例
// baseURL 使用 /api，通过 vue.config.js 中的 proxy 代理到后端 9999 端口
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 360000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前添加 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-token'] = token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    // eslint-disable-next-line no-console
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 如果请求的是 blob 类型（如图片），直接返回
    if (response.config.responseType === 'blob') {
      return response.data;
    }
    
    const res = response.data;
    
    // 检查后端返回的状态码
    if (res.code !== API_CODE.SUCCESS && res.code !== 200) {
      // Token 过期或无效
      if (res.code === API_CODE.TOKEN_EXPIRED || res.code === 1001) {
        handleLoginExpired();
        return Promise.reject(new Error('Token expired'));
      }
      
      // 违规词错误 - 特殊处理
      if (res.code === API_CODE.BANNED_WORD) {
        handleBannedWordError(res);
        return Promise.reject(new Error(res.message || '包含违规词'));
      }
      
      showErrorMessage(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    
    return res;
  },
  (error) => {
    let message = '网络错误';
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求参数错误';
          break;
        case 401:
          handleLoginExpired();
          return Promise.reject(new Error('Token expired'));
        case 403:
          message = '拒绝访问';
          break;
        case 404:
          message = '请求地址不存在';
          break;
        case 500:
          message = '服务器内部错误';
          break;
        case 502:
          message = '网关错误';
          break;
        case 503:
          message = '服务不可用';
          break;
        case 504:
          message = '网关超时';
          break;
        default:
          message = `连接错误${error.response.status}`;
      }
    } else if (error.request) {
      message = '无法连接到服务器';
    }
    
    showErrorMessage(message);
    
    // eslint-disable-next-line no-console
    console.error('Response error:', error);
    return Promise.reject(error);
  }
);

export default service;
